import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=64551332&"
import script from "./NotificationDetails.vue?vue&type=script&lang=ts&"
export * from "./NotificationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports